import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem, Checkbox } from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { IoMdAdd as AddIcon } from "react-icons/io";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import styled from "@emotion/styled";
import { atom, useAtom } from 'jotai';
import apiCall from '../../../../utils/apiCall';
import {TopLink} from '../';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
import { Formik,Form,Field } from "formik";
import {TablePopUp} from '../../../../components';
import * as Yup from 'yup';
import { format } from "date-fns";
import { Loader } from "../../../../customs";
import ReactPaginate from 'react-paginate';
import { TbReload as ReloadIcon } from "react-icons/tb";


const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type > *{
    display:none;
  }
  :hover > td{
    background-color:var(--table-highlight);
    &:last-of-type > *{
      display:block;
    }
  } 
  &.active > td:last-of-type > *{
    display:block !important;
  }  
`

// const allLevel = [
//   {
//     Id:1,
//     Name:"1"
//   },
//   {
//     Id:2,
//     Name:'2'
//   },
//   {
//     Id:3,
//     Name:'3'
//   },
//   {
//     Id:4,
//     Name:'4'
//   }
// ]

const StudyCenterAtom = atom<number | null>(null);


export default function StudyCenter() {
  const [hide,set_hide] = useState<boolean>(true);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_open] = useAtom(openAtom);
  const [active] = useAtom<number | string | null>(StudyCenterAtom);

  const {data:allCountries} = useQuery(['contry'],{
    queryFn:async ()=> await apiCall().get(`/Country/GetCountrys`),
    select(data){
     // console.log(data,'countries')
      return data.data;
    },
  })
   const {data:allStates} = useQuery(['state'],{
    queryFn:async ()=> await apiCall().get(`/State/GetAllStates`),
    select(data){
       //console.log(data,'states')
      return data.data;
    },
  })


  const {isLoading,data:allStudyCenter} = useQuery(['study-center'],{
    queryFn:async ()=> await apiCall().get(`/exam/setup/studyCenter
    `),
    select(data){
      //console.log(data,'studey-centers')
      return data.data.Data;
    }
  })
  const [search,set_search] = useState('');
  const [filter_data,set_filter_data] = useState<any>(allStudyCenter);
  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join(allStudyCenter).toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data('')
    }
    else set_filter_data(allStudyCenter)
  }
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };
  useEffect(()=>{
    set_filter_data(allStudyCenter)
  },[allStudyCenter])




  const handleAddStudyCenter = () =>{
    set_modal({
      header:'Add Study Center',
      content:<AddType />
    })
    set_open(true);
}

  return (
    <>
    {isLoading?<Loader />:
    <Box>
      <TopLink />
      <TopDisplay label="Study Center" button_array={[
          <Button onClick={handleAddStudyCenter} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Add Study Center</Button>
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          {/* <Select placeholder="Center" width="150px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)">
              {allCountries && allCountries.length  > 0?
               allCountries.map((eCountry:any) =>
                <option key={eCountry.CountryId}>{eCountry.CountryName}</option>
               )
              :'' }
          </Select> */}
          

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                {/* <Th sx={HeadStyle}>ID</Th> */}
                <Th sx={HeadStyle}>Center Name</Th>
                <Th sx={HeadStyle}>State</Th>
                <Th sx={HeadStyle}>Country</Th>
                <Th sx={HeadStyle}>Contact Address</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eStudyCenter:any) =><ROWSTYLE key={eStudyCenter.Id} className={eStudyCenter.Id === active?'active':''}>
                <Td sx={DataStyle}>{eStudyCenter.Name}</Td>
                <Td sx={DataStyle}>{allStates && allStates.find((eSub:any) => eSub.StateId == eStudyCenter.StateId)?.StateName || 'N/A'}</Td>
                <Td sx={DataStyle}>{allCountries && allCountries.find((eState:any)=> eState.CountryId == eStudyCenter.CountryId)?.CountryName || ''}</Td>
                <Td sx={DataStyle}>{eStudyCenter.ContactAddress || 'N/A'}</Td>
                {/* <Td sx={DataStyle}></Td> */}
                <Td sx={DataStyle} w="50px" h="50px">
                  <TempPopUp index={eStudyCenter.Id} data={eStudyCenter}/>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No  Study Center'  
      }
       <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
    }
    </>
    
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

// function set_modal(arg0: { header: string; content: import("react/jsx-runtime").JSX.Element; }) {
//   throw new Error("Function not implemented.");
// }

// function set_open(arg0: boolean) {
//   throw new Error("Function not implemented.");
// }

const AddSchema = Yup.object({
  Name:Yup.string().required(),
  StateId:Yup.number().required(),
  CountryId:Yup.number().required(),
  ContactAddress:Yup.string()
});

const AddType = (props:any) =>{
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const [selected_country,set_selected_country] = useState<undefined | string | number>('');
  const [active_states,set_active_states] = useState<any>([]);

  const {data:allCountries} = useQuery(['countrys'],{
    queryFn:async ()=> await apiCall().get(`/Country/GetCountrys`),
    select(data:any){
      //console.log(data,'all countries')
      return data.data;
    },
  })
   const {data:allStates} = useQuery(['states'],{
    queryFn:async ()=> await apiCall().get(`/State/GetAllStates`),
    select(data:any){
      //console.log(data,'all states')
      return data.data?.sort((a:any,b:any) => a.StateName - b.StateName);
    },
  })

  
  // const {data:allLevel} = useQuery(['exam-level'],{
  //   queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
  //   select(data){
  //     return data.data.Data;
  //   }
  // })
  const handleSelectCountry = (e:any) =>{
    let value = Number(e?.target?.value || 0);
    set_selected_country(value);
    let tempStates:any[] = []; 
    if(value){
      tempStates= allStates.filter((eState:any)=>eState.CountryId == value);

    }
    else{
      tempStates = allStates;
    }
    //console.log(tempStates,'states');
    set_active_states(tempStates);
    
  }

  const {mutate:addUpdate,isLoading} = useMutation({
    mutationKey:['new-study-center'],
    mutationFn:async (data:any)=> {
      return props && props.Id?await apiCall().put(`/exam/setup/studyCenter/${props.Id}`,data):await apiCall().post(`/exam/setup/studyCenter`,data)},
    onSuccess:(data)=>{
      console.log(data,'new data')
      set_notification({
        type:'success',
        message:data?.data?.Message || 'Added Successfully'
      })
      set_Nopen(true);
      queryClient.invalidateQueries({
        queryKey:['study-center']
      });
    },
    onError(error:any){
      set_notification({
        type:'error',
        message:error?.data?.Message || 'Error Occured'
      })
      set_Nopen(true);
    },
    onSettled:()=>{
      set_open(false);
    }
  })

  useEffect(()=>{
    if(allStates){
      set_active_states(allStates);
    }
  },[allStates])

  return (
    <Formik
    initialValues={{
      Name: props.Name || '',
      StateId: props.StateId || '',
      CountryId: selected_country || props.CountryId || '',
      ContactAddress: props.ContactAddress || '',
    }}
    validationSchema={AddSchema}
    onSubmit={(values: any) => {
      const data = {
        Name: values.Name,
        StateId: values.StateId,
        CountryId: values.CountryId,
        ContactAddress: values.ContactAddress,
      };
      addUpdate(data);
    }}
  >
    {(formik: any) => {
      const { errors, values } = formik;
  
      // Check if selected_country has been set
      if (!values.CountryId && selected_country) {
        values.CountryId = selected_country;
      }
  
      return (
        <Form>
          <Flex flexDir={"column"} align={"center"} gap="20px">
            <Field as={Input}
              flexDir={"column"} align={"center"} gap="20px"
              size="md"
              borderColor='var(--dark-green-color)'
              name="Name"
              placeholder="Center Name"
              type="text"
              inputMode="Text"
            />
  
            {/* Country Select */}
            <Field as={Select}
              bg='var(--white-color)'
              borderColor='var(--dark-green-color)'
              color='var(--dark-green-color)'
              placeholder='Country'
              name="CountryId"
              onChange={handleSelectCountry}
              value={values.CountryId || selected_country} // Ensure selected_country is set
            >
              {allCountries && allCountries.length > 0 ?
                allCountries.map((eType: any) => <option key={eType.CountryId} value={eType.CountryId}>{eType.CountryName}</option>)
                : ''
              }
            </Field>
  
            {/* State Select */}
            <Field as={Select}
              bg='var(--white-color)'
              borderColor='var(--dark-green-color)'
              color='var(--dark-green-color)'
              placeholder='State'
              name="StateId"
            >
              {active_states && active_states.length > 0 ?
                active_states.map((eType: any) => <option key={eType.StateId} value={eType.StateId}>{eType.StateName}</option>)
                : ''
              }
            </Field>
  
            <Field as={Input}
              flexDir={"column"} align={"center"} gap="20px"
              size="md"
              name="ContactAddress"
              borderColor='var(--dark-green-color)'
              placeholder="Enter Contact Address"
              type="text"
              inputMode="Text"
            />
  
            <Button disabled={isLoading} type="submit" bg="var(--dark-green-color)" color="var(--white-color)">
              {isLoading ? "Loading" : 'Submit'}
            </Button>
          </Flex>
        </Form>
      );
    }}
  </Formik>
  
  )

}

const TempPopUp = (props:any) =>{
  const index = props.index;
  const data = props.data;
  // console.log(data,'data')
  const [active,set_active] = useAtom(StudyCenterAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const queryClient = useQueryClient();


  const {data:allCountries} = useQuery(['countrys'],{
    queryFn:async ()=> await apiCall().get(`/Country/GetCountrys`),
    select(data:any){
      //console.log(data,'all countries')
      return data.data;
    },
  })

  const {data:allStates} = useQuery(['states'],{
    queryFn:async ()=> await apiCall().get(`/State/GetAllStates`),
    select(data:any){
      //console.log(data,'all states')
      return data.data?.sort((a:any,b:any) => a.StateName - b.StateName);
    },
  })

  const {mutate:deleteFee,isLoading} = useMutation({
    mutationKey:['delete-study-center'],
    mutationFn:async () => await apiCall().delete(`/exam/setup/studyCenter/${data?.Id}/delete`),
    onSuccess(data:any) {
      queryClient.invalidateQueries({queryKey:["study-center"]})
      set_notification({
        type:'success',
        message:data?.data?.Message || 'Deleted Successfully'
      })
      set_Nopen(true);
    },
    onSettled(){
      set_open(false);
    }
  })

  const handleClick = () =>{
    if(index === active){
      set_active(null);
      return;
    }
    else{
      set_active(index);
    }
  }
  const handleView= () =>{
    set_modal({
      header:'View Study Center Setup',
      content:<Grid>
        {/* <GridItem justify="space-between" p="10px 0" as={Flex}>
          <span>Id</span>
          <span>{data?.Id}</span>
        </GridItem > */}
        <GridItem justify="space-between" p="10px 0" as={Flex}>
          <Text fontWeight="bold">Name:</Text>
          <span>{data?.Name}</span>
        </GridItem >
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <Text fontWeight="bold">State:</Text>
          <span>{allStates && allStates.find((eSub:any) => eSub.StateId == data.StateId)?.StateName || 'N/A'}</span>
        </GridItem>
        <GridItem as={Flex} justify="space-between" p="10px 0">
          <Text fontWeight="bold">Country:</Text>
          <span>{allCountries && allCountries.find((eState:any)=> eState.CountryId == data.CountryId)?.CountryName || ''}</span>
        </GridItem>
      </Grid>
    })
    set_open(true);
    handleClick();
  }
  const handleEdit = () =>{
    handleClick();
    set_modal({
      header:'Edit Study Center',
      content:<AddType {...data}/>
    });
    set_open(true);
    handleClick();
    
  }
  const handleDisable = () =>{
    set_modal({
      header:'Disable Study Center',
      content:<Grid gap="20px">
        <GridItem>Are you Sure you want to disable this Study Center?</GridItem>
        <GridItem as={Flex} justify="space-between" p="20px 0">
          <Button disabled={isLoading} onClick={()=>deleteFee()} bg="var(--dark-green-color)"
            color="var(--white-color)" >{isLoading?'Loading':'Disable'}</Button>
          <Button disabled={isLoading} 
            variant="outline" bg="var(--white-color)"
            onClick={()=>set_open(false)}
            border="1px solid var(--dark-green-color)"
            color="var(--dark-green-color)" >Cancel</Button>
        </GridItem>
      </Grid>
    });
    set_open(true);
  }
  
  return (
    <TablePopUp click={handleClick} options={[
      {label:'View details',click:handleView},
      {label:'Edit Center',click:handleEdit},
      {label:'Disable Center',click:handleDisable}
    ]} />
  )
}

